import React, { useEffect, useState } from 'react';
import { ListIcon } from 'lucide-react';
export interface GuideSection {
  id: string;
  label: string;
}
interface GuideTocProps {
  sections: GuideSection[];
}
export function GuideToc({
  sections
}: GuideTocProps) {
  const [activeId, setActiveId] = useState<string>(sections[0]?.id ?? '');
  useEffect(() => {
    if (sections.length === 0) return;
    const handleScroll = () => {
      let current = sections[0].id;
      sections.forEach(section => {
        const element = document.getElementById(section.id);
        if (!element) return;
        if (element.getBoundingClientRect().top <= 160) {
          current = section.id;
        }
      });
      setActiveId(current);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);
  if (sections.length === 0) return null;
  return <nav aria-label="Table of contents" className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm lg:sticky lg:top-28" data-id="element-448" data-mp="208i2hz5duvjh">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-gray-500" data-id="element-449" data-mp="18vjxf1xfh2jc">
        <ListIcon size={14} className="text-zano-pink" aria-hidden="true" data-id="element-450" data-mp="v4etvoqxvq3q" /> On this page
      </p>
      <ol className="mt-4 space-y-1" data-id="element-451" data-mp="102zys1h4yxyi">
        {sections.map((section, index) => {
        const isActive = section.id === activeId;
        return <li key={section.id} data-id="element-452" data-mp="l4nzdn2dpb3n" data-mpi={index}>
              <a href={`#${section.id}`} aria-current={isActive ? 'true' : undefined} className={`flex gap-2.5 rounded-lg px-2.5 py-2 text-sm leading-snug transition-colors ${isActive ? 'bg-zano-blush font-semibold text-zano-pink' : 'text-gray-600 hover:bg-gray-50 hover:text-zano-charcoal'}`} data-id="element-453" data-mp="q5271402ij15">
                <span className={`shrink-0 text-xs font-bold ${isActive ? 'text-zano-pink' : 'text-gray-400'}`} data-id="element-454" data-mp="2biergt2bb3nt">
                  {String(index + 1).padStart(2, '0')}
                </span>
                {section.label}
              </a>
            </li>;
      })}
      </ol>
    </nav>;
}